export default __webpack_public_path__ + "static/media/harbolkick-category-sneakers.b8db12fc.png";